module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA20lEQVR4AWOgCzgnqEYkIlcDg307FFm2yAZP7ly9ecvZHTsv7Ju0Ybdi6DSgIFwBugZ+977lh3YfurC8bnVS7iy33ScXrjt+SNBzAk4NwY0rLl7deXNhypKVhS3dXlPiA87d2BHStAKnhsKpax6/u/H95dO7p048ONrx+t7dx+9uFk5bjVNDRNOqq0+PXXh0pGXjtNZ1bZcfHL336kJYI24bgM5deXjXvsvr1hxdsOrwkq1nlq89uk/Qsx+nBgbLZsXQ6dM27N197si+88cnrd+pFIYSSnSIuEEJALOavv+bhArBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BZ.png
// module id = 1102
// module chunks = 0